<template>
  <div class="tech_advantages">
    <h1>智能科技 变革未来</h1>
    <p class="topP">以无人化、集群化、智能化为产品理念，打造全空间、全方位产业解决方案</p>
    <div class="btnCom">
      <span class="txt" @click="navigateToAboutUs">了解华软 ></span>
    </div>
    <el-row class="stats">
      <el-col :span="6" class="relative">
        <div class="stat_item">
          <!-- <img src="path/to/icon1.png" alt="专利数量"> -->
          <img src="@/assets/home/zhuanNum.png" alt="" />
          <div class="flex-column">
            <span class="num">
              500<span class="sup">+</span>
            </span>
            <div class="stat-label">专利数量</div>
          </div>

        </div>
        <div class="div_line"></div>
      </el-col>
      <el-col :span="6" class="relative">
        <div class="stat_item">
          <img src="@/assets/home/proType.png" alt="" />
          <div class="flex-column">
            <span class="num">
              80<span class="sup">+</span>
            </span>
            <div class="stat-label">产品类型</div>
          </div>
        </div>
        <div class="div_line"></div>
      </el-col>
      <el-col :span="6" class="relative">
        <div class="stat_item">
          <img src="@/assets/home/haveUser.png" alt="" />
          <div class="flex-column">
            <span class="num">
              300<span class="sup">+</span>
            </span>
            <div class="stat-label">研发员工</div>
          </div>
        </div>
        <div class="div_line"></div>
      </el-col>
      <el-col :span="6" class="relative">
        <div class="stat_item">
          <img src="@/assets/home/flyHour.png" alt=""  style="height: 78px;"/>
          <div class="flex-column">
            <span class="num">
              50<span class="sup" style="right: -45PX;">万+</span>
            </span>
            <div class="stat-label">运行时长</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <h2 class="hexin">核心技术优势</h2>
    <div class="heTxt">专注于为用户提供全空间“无人化、集群化、智能化”行业产品和解决方案，助力用户实现数智化转型升级</div>
    <el-row class="advantages">
      <el-col :span="12" class="col_item">
        <div class="advantage_item">
          <img src="@/assets/home/noPer.png" alt="无人值守" class="advantage-icon" />
          <h3>具身智能</h3>
        </div>
        <p>具有无人系统大脑、小脑及执行机构核心全要素全域技术，具备多模态自主感知、自主决策、智能执行能力，实现全域空间无人体系和装备复杂场景应用能力。</p>
      </el-col>
      <!-- <el-col :span="12" class="col_item">
        <div class="advantage_item">
          <img src="@/assets/home/jiKong.png" alt="集控飞行" class="advantage-icon" />
          <h3>异构协同</h3>
        </div>
        <p>具备在陆、海、空、天不同空间异构无人系统及装备的自主协同与作业能力</p>
      </el-col> -->
      <el-col :span="12" class="col_item">
        <div class="advantage_item">
          <img src="@/assets/home/aiChu.png" alt="智能处理" class="advantage-icon" />
          <h3>群体智能</h3>
        </div>
        <p>具有陆、海、空不同空间异构无人系统及装备的自主集群协同与作业能力，具备强鲁棒性、可扩展性、自组织与适应性能力，实现泛化全域空间多元复杂应用场景无人自主高效交互和作业。</p>
      </el-col>
      <!-- <el-col :span="12" class="col_item">
        <div class="advantage_item">
          <img src="@/assets/home/safe.png" alt="安全可靠" class="advantage-icon" />
          <h3>安全可靠</h3>
        </div>
        <p>全方位安全防护，确保系统运行稳定可靠</p>
      </el-col> -->
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {
    navigateToAboutUs() {
      this.$router.push({ path: '/about_us' });
    }
  }
}
</script>

<style lang="scss" scoped>
.tech_advantages {
  text-align: center;
  padding: 80PX 0;
  font-family: PingFang SC;
  letter-spacing: 0PX;
  opacity: 1;
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
  /* 可选：保证内容不会溢出 */
  box-sizing: border-box;

  h1 {

    font-size: 32PX;
    font-weight: bold;

    color: #1E242A;
    margin-bottom: 12PX;
  }

  .topP {
    opacity: 0.6;
    font-size: 20PX;
    /* 1E242A */
    color: #1E242A;
    margin-bottom: 20PX;
  }

  .btnCom {
    opacity: 0.4;
    font-size: 16PX;
    margin-bottom: 40PX;

    .txt {
      cursor: pointer;
    }
  }

  .relative {
    position: relative;
  }

  .stats {

    // padding: 0PX 18.75%;
    height: 160PX;
    align-items: center;
    display: flex;
    margin-bottom: 80PX;

    .stat_item {
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 12PX;

      .flex-column {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }

      .stat-label {
        font-size: 16PX;
        color: #1E242A;
      }

      img {
        width: 88PX;
        height: 88PX;
      }


      .num {
        font-size: 36PX;
        font-weight: bold;
        letter-spacing: 0PX;
        position: relative;
        color: #1E242A;

        .sup {
          position: absolute;
          color: #1E242A;
          right: -23PX;
          font-size: 16PX;
          font-weight: normal;
          color: #1E242A;
          font-size: 20PX;
          font-weight: bold;
          line-height: 32PX;
          letter-spacing: 0PX;
        }
      }
    }

    .div_line {
      position: absolute;
      right: 0px;
      top: 30PX;
      border-radius: 5PX;
      width: 3PX;
      height: 40PX;
      background: rgba(15, 107, 246, 0.1);
    }

  }

  .hexin {
    font-family: PingFang SC;
    font-size: 32PX;
    font-weight: bold;
    line-height: normal;
    letter-spacing: 0PX;

    font-variation-settings: "opsz" auto;
    color: #1E242A;
  }

  .heTxt {
    opacity: 0.6;
    font-size: 16PX;
    line-height: 28PX;
    letter-spacing: 0PX;
    margin-top: 12PX;
    color: #1E242A;
    margin-bottom: 40PX;
  }

  .advantages {
    padding: 32px 0;
    background: linear-gradient(180deg, rgba(244, 246, 249, 0.6) -42%, rgba(244, 246, 249, 0.1) 142%);
    border: 1px solid rgba(15, 107, 246, 0.08);
    border-radius: 8px;
    display: flex;
    background: linear-gradient(180deg, rgba(244, 246, 249, 0.6) 0%, rgba(244, 246, 249, 0.1) 99%);
    border: 1px solid rgba(15, 107, 246, 0.08);
    .col_item {
      padding-left: 32px;
      p {
        font-size: 16PX;
        padding-right: 60PX;
      }
      &:nth-child(2n - 1){
        border-right: 1PX solid rgba(15, 107, 246, 0.08);
      }
      // &:nth-child(1) {
      //   border-right: none;
      //   border-bottom: none;
      //   height: 165PX;
      // }

      // &:nth-child(2) {
      //   border-bottom: none;
      //   height: 165PX;
      // }

      // &:nth-child(3) {
      //   border-right: none;
      // }
    }

    .advantage_item {
      padding: 0 20px 8px;
      display: flex;
      align-items: center;
      gap: 12PX;
      padding-right: 60PX;
      border-radius: 8PX;

      .advantage-icon {
        width: 32PX;
        height: 32PX;
      }

      h3 {
        font-family: PingFang SC;
        font-size: 20PX;
        font-weight: bold;
        line-height: normal;
        text-align: center;
        letter-spacing: normal;
        color: #1E242A;
      }

      p {
        font-family: PingFang SC;
        font-size: 16PX;
        font-weight: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #1E242A;
        margin-top: 10PX;
      }
    }

    p {
      padding-left: 65PX;
      // padding-bottom: 20PX;
      text-align: left;
    }
  }


}
</style>